import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { GalleryDetail } from '../model/gallery-detail.model';
import { Gallery } from '../../model/gallery.model';
import { GalleryDetailResponse } from '../model/gallery-detail-response.model';



@Injectable({
  providedIn: 'root'
})
export class GalleryDetailService {

  private apiUrl = environment.baseApiUrl + '/galleries';

  constructor(private http: HttpClient) { }

  getGalleryById(id: number): Observable<GalleryDetailResponse> {
    return this.http.get<GalleryDetailResponse>(`${this.apiUrl}/${id}`);
  }

}
